/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_External_BookingsInputs */

const en_admin_discounts_external_bookings = /** @type {(inputs: Admin_Discounts_External_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External Bookings`)
};

const de_admin_discounts_external_bookings = /** @type {(inputs: Admin_Discounts_External_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externe Buchungen`)
};

const es_admin_discounts_external_bookings = /** @type {(inputs: Admin_Discounts_External_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservas externas`)
};

const fr_admin_discounts_external_bookings = /** @type {(inputs: Admin_Discounts_External_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservations externes`)
};

/** @type {(inputs: Admin_Discounts_External_BookingsInputs) => LocalizedString} */
const it_admin_discounts_external_bookings = en_admin_discounts_external_bookings;

/** @type {(inputs: Admin_Discounts_External_BookingsInputs) => LocalizedString} */
const pt_br2_admin_discounts_external_bookings = en_admin_discounts_external_bookings;

/** @type {(inputs: Admin_Discounts_External_BookingsInputs) => LocalizedString} */
const pl_admin_discounts_external_bookings = en_admin_discounts_external_bookings;

/** @type {(inputs: Admin_Discounts_External_BookingsInputs) => LocalizedString} */
const hu_admin_discounts_external_bookings = en_admin_discounts_external_bookings;

/** @type {(inputs: Admin_Discounts_External_BookingsInputs) => LocalizedString} */
const ro_admin_discounts_external_bookings = en_admin_discounts_external_bookings;

/**
* | output |
* | --- |
* | "External Bookings" |
*
* @param {Admin_Discounts_External_BookingsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_external_bookings = /** @type {((inputs?: Admin_Discounts_External_BookingsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_External_BookingsInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_external_bookings(inputs)
	if (locale === "de") return de_admin_discounts_external_bookings(inputs)
	if (locale === "es") return es_admin_discounts_external_bookings(inputs)
	if (locale === "fr") return fr_admin_discounts_external_bookings(inputs)
	if (locale === "it") return it_admin_discounts_external_bookings(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_external_bookings(inputs)
	if (locale === "pl") return pl_admin_discounts_external_bookings(inputs)
	if (locale === "hu") return hu_admin_discounts_external_bookings(inputs)
	return ro_admin_discounts_external_bookings(inputs)
});
export { admin_discounts_external_bookings as "admin.discounts.external_bookings" }